<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col class="col-12">
                    <ValidationProvider name="kilometer" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('kilometer')">
                            <b-form-input :validate-error="errors[0]" v-model="form.kilometer"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col v-for="n in 5" :key="n" class="col-12 mb-3">
                    <ValidationProvider
                        :name="$t('file') + ' ' + n"
                        rules="required"
                        v-slot="{ valid, errors, validate }"
                    >
                        <b-form-group :label="$t('file') + ' ' + n">
                            <div class="d-flex custom-file-upload">
                                <b-form-file
                                    v-model="form['file_' + n]"
                                    :ref="'fileInput' + n"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :placeholder="$t('select_file')"
                                    :drop-placeholder="$t('drop_file')"
                                    accept="image/jpeg, image/png"
                                ></b-form-file>

                                <b-button variant="outline-secondary"
                                          @click="$refs['fileInput' + n][0].$el.childNodes[0].click();">
                                    {{ $t('browse') }}
                                </b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

            </b-row>
            <b-button @click="saveForm" :disabled="formLoading" variant="primary">
                {{ $t('save') }}
            </b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import CarReservationService from "@/services/CarReservationService";

    export default {
        props: {
            formId: {
                type: Number
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,

        },
        watch: {
            formId: {
                immediate: true,
                handler(value) {
                    this.form.car_reservation_id = value;
                }
            },
        },
        data() {
            return {
                formLoading: false,
                form: {
                    car_reservation_id: null,
                    kilometer: null,
                    file_1: null,
                    file_2: null,
                    file_3: null,
                    file_4: null,
                    file_5: null,
                },
            }
        },
        methods: {
            async saveForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    const formData = new FormData();

                    formData.append('car_reservation_id', this.form.car_reservation_id);
                    formData.append('status', this.form.status);
                    formData.append('kilometer', this.form.kilometer);

                    for (let i = 1; i <= 5; i++) {
                        const fileKey = `file_${i}`;
                        if (this.form[fileKey]) {
                            formData.append(fileKey, this.form[fileKey]);
                        }
                    }

                    CarReservationService.receiveReservation(formData)
                                 .then((response) => {
                                     this.$toast.success(this.$t("api." + response.data.message));
                                     this.$emit("receiveReservationFormSuccess")
                                 })
                                 .catch((error) => {
                                     this.showErrors(error, this.$refs.formModalValidate)
                                 });
                }
            }
        }
    }
</script>
